var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvtarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23296",
    "data-name": "Path 23296",
    d: "M267.5,120.831v3.25a3.751,3.751,0,0,1-3.75,3.75h-27.5a3.751,3.751,0,0,1-3.75-3.75v-3.25a10.5,10.5,0,0,1,10.5-10.5c2.25,0,3.32,1.25,7,1.25s4.758-1.25,7-1.25a10.5,10.5,0,0,1,10.5,10.5m-2.5,0a8.005,8.005,0,0,0-8-8c-1.531,0-3.062,1.25-7,1.25s-5.469-1.25-7-1.25a8.005,8.005,0,0,0-8,8v3.25a1.254,1.254,0,0,0,1.25,1.25h27.5a1.254,1.254,0,0,0,1.25-1.25Zm-25-23a10,10,0,1,1,10,10,10,10,0,0,1-10-10m2.5,0a7.5,7.5,0,1,0,7.5-7.5,7.512,7.512,0,0,0-7.5,7.5",
    transform: "translate(-232.5 -87.831)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtarWhite);
export default __webpack_public_path__ + "static/media/avtarWhite.3a415222a5ebdda127283cdc6d331f79.svg";
export { ForwardRef as ReactComponent };